import React, { useCallback, useMemo, useState } from "react";
import { PollingGateContext } from "./usePollingGate";

/** DBCO-0062 - holds the busy count the detail query reads (see `usePollingGate`). */
export const PollingGateProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [holders, setHolders] = useState(0);
  const register = useCallback(() => {
    setHolders((count) => count + 1);
    let released = false;
    return () => {
      if (!released) {
        released = true;
        setHolders((count) => count - 1);
      }
    };
  }, []);
  const value = useMemo(() => ({ busy: holders > 0, register }), [holders, register]);
  return <PollingGateContext.Provider value={value}>{children}</PollingGateContext.Provider>;
};

export default PollingGateProvider;
